import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationStratalotTodoRuleApiService } from '@_services/api/organization-stratalot-todo-rule-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationStratalotTodoRuleEffects } from './organization-stratalot-todo-rule-generated.effects';

@Injectable()
export class OrganizationStratalotTodoRuleEffects extends GeneratedOrganizationStratalotTodoRuleEffects {
  constructor(
    actions$: Actions,
    organizationStratalotTodoRuleApiService: OrganizationStratalotTodoRuleApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationStratalotTodoRuleApiService, store$);
  }
}
